import { render, staticRenderFns } from "./QuoteItemPresentAsModal.vue?vue&type=template&id=142f9060&scoped=true"
import script from "./QuoteItemPresentAsModal.vue?vue&type=script&lang=js"
export * from "./QuoteItemPresentAsModal.vue?vue&type=script&lang=js"
import style0 from "./QuoteItemPresentAsModal.vue?vue&type=style&index=0&id=142f9060&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142f9060",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('142f9060')) {
      api.createRecord('142f9060', component.options)
    } else {
      api.reload('142f9060', component.options)
    }
    module.hot.accept("./QuoteItemPresentAsModal.vue?vue&type=template&id=142f9060&scoped=true", function () {
      api.rerender('142f9060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaModal/QuoteItemPresentAsModal.vue"
export default component.exports